import { HttpPlanOrderList } from '@/service/salesreturns';
import TableList from "@components/templates/tablelist";
import { mapGetters } from 'vuex';
export default {
    mixins: [TableList],
    data() {
        return {
            isMixin: true,
            Searchs: {
                show: true,
                style: "border:none;",
                labelWidth: 'auto',
                align: "left"
            },
            formData: {
                'search[IN_saleReturnPlanStatus]': '10,20,30'
            }
        };
    },
    methods: {
        ajaxRequest: HttpPlanOrderList,
        handleOperates(data) {
            this.$emit('on-data', data)
        },
    },
    computed: {
        ...mapGetters('dictionary', ['getCusproductList', 'getBillcusWareList']),
        SearchsData() {
            return [
                {
                    label: this.$t('fbb.sales_return.planbill', { defaultValue: "销售退货计划单号" }),
                    key: 'EQ_saleReturnPlanNo',
                    show: true,
                    tag: 'vInput',
                },
                {
                    label: this.$t('global.common.warehouse', { defaultValue: "仓库" }),
                    key: 'EQ_orgWarehouseCode',
                    tag: 'vSelect',
                    options: this.getBillcusWareList.map(item => {
                        return {
                            label: item.label,
                            value: item.attach.code
                        }
                    }),
                    show: true,
                    props: {
                        filterable: true,
                    },
                },
                {
                    label: this.$t('global.common.project', { defaultValue: "项目" }),
                    key: 'EQ_lineId',
                    tag: 'vSelect',
                    options: this.getCusproductList,
                    show: true,
                    props: {
                        filterable: true,
                    },
                },
                {
                    label: this.$t('global.common.sourceNo', { defaultValue: "来源单号" }),
                    key: 'EQ_sourceNo',
                    tag: 'vInput',
                    show: true,
                },
            ]
        },
        columns() {
            return [
                {
                    type: 'index',
                    width: 60,
                }, {
                    title: this.$t('fbb.sales_return.planbill', { defaultValue: "销售退货计划单号" }),
                    key: 'saleReturnPlanNo',
                }, {
                    title: this.$t('global.common.sourceNo', { defaultValue: "来源单号" }),
                    key: 'sourceNo',
                }, {
                    title: this.$t('global.common.project', { defaultValue: "项目" }),
                    key: 'lineId',
                    render: (h, { row }) => this.findRenderLabel(this.getCusproductList, row.lineId)
                }, {
                    title: this.$t('global.common.warehouse', { defaultValue: "仓库" }),
                    key: 'orgWarehouseCode',
                }, {
                    title: '操作',
                    width: 90,
                    align: 'center',
                    render: (h, { row }) => {
                        return <vButton theme='primary' onClick={this.handleOperates.bind(this, row)}>{this.$t('global.common.chooice', { defaultValue: '选择' })}</vButton>
                    }
                }];
        },
    },
};




